import styled from 'styled-components';

const Wrapper = styled.div`
display:block;
margin: 20px auto;
padding: 10px;
min-width: 250px;
-webkit-user-select: none;
-khtml-user-select: none;
-moz-user-select: none;
-o-user-select: none;
user-select: none;
user-drag: none;
-webkit-user-drag: none;
`
const BigTitle = styled.div`
font-size: 2.5rem;
margin-left: 10px;
padding: 5px;
color: ${props => props.theme.colors.texte};;
`
const SmallTitle = styled.div`
font-size: 1.4rem;
color: ${props => props.theme.colors.texte_second};;
`

const ImgLogo = styled.img`
float:left;
-webkit-user-select: none;
-khtml-user-select: none;
-moz-user-select: none;
-o-user-select: none;
user-select: none;
user-drag: none;
-webkit-user-drag: none;
`
const TextWrapper = styled.div`
margin-top:0px;
`

const Logo = () => {

    return (
    <Wrapper>
        <ImgLogo src="/img/momLogo.png"></ImgLogo>
        <TextWrapper>
            <BigTitle>IGLS Data</BigTitle>
            <SmallTitle>Inscriptions grecques et latines de la Syrie</SmallTitle>
        </TextWrapper>
    </Wrapper>
    )
}

export default Logo;